import React from "react";
import { Phone, Mail } from "lucide-react";
import {
  PHONE_DISPLAY,
  PHONE_HREF,
  EMAIL,
  EMAIL_HREF,
  BRAND_NAME,
} from "@/lib/contact";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-nav-950 border-t border-nav-800 text-nav-300 pt-16 pb-10"
    >
      <div className="container-x">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="grid place-items-center h-9 w-9 rounded-lg bg-brand text-white font-display font-bold">
                CB
              </span>
              <span className="font-display font-bold text-lg text-white">
                {BRAND_NAME}
              </span>
            </div>
            <p className="mt-4 text-sm text-nav-400 max-w-sm leading-relaxed">
              Booking funnels for owner-operated businesses. Built for
              appointment-based and membership niches that are tired of losing
              clients in DMs.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.18em] text-nav-500 font-semibold">
              Quick Links
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href="#problem" className="hover:text-white">
                  Why
                </a>
              </li>
              <li>
                <a href="#who-this-is-for" className="hover:text-white">
                  Who it's for
                </a>
              </li>
              <li>
                <a href="#pricing" className="hover:text-white">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-white">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-white">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.18em] text-nav-500 font-semibold">
              Get in touch
            </p>
            <a
              href={PHONE_HREF}
              data-testid="footer-phone"
              className="mt-4 flex items-center gap-3 text-white hover:text-brand"
            >
              <Phone className="h-4 w-4" />
              <span className="font-display font-bold text-lg">
                {PHONE_DISPLAY}
              </span>
            </a>
            <a
              href={EMAIL_HREF}
              data-testid="footer-email"
              className="mt-2 flex items-center gap-3 text-nav-300 hover:text-white"
            >
              <Mail className="h-4 w-4" />
              <span>{EMAIL}</span>
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-nav-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-nav-500">
          <p>
            © {year} {BRAND_NAME}. All rights reserved.
          </p>
          <p>Built for appointment-based & membership businesses.</p>
        </div>
      </div>
    </footer>
  );
}
